import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Santiago_Hernandez
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de Investigación y desarrollo (REFORMULACIÓN) 
 **/
class CustomInvestigacionYDesarrollo extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);


        this.gridOptionsEnvasadoInicialMaterialEmpaque = Object.assign({}, this.gridOptions);
        this.gridOptionsProductosEnvasado = Object.assign({}, this.gridOptions);
        this.gridOptionsMaterialEmpaque = Object.assign({}, this.gridOptions);
        this.gridOptionsSaldos = Object.assign({}, this.gridOptions);
        this.gridOptionsVerFormula = Object.assign({}, this.gridOptions);


        this.successDatosFicha = this.successDatosFicha.bind(this);
        this.itemsFichas = this.itemsFichas.bind(this);
        this.successItemFichas = this.successItemFichas.bind(this);
        this.tamanoDatos = 0;
        this.openModalGrabar = this.openModalGrabar.bind(this);
        this.grabarItem = this.grabarItem.bind(this);
        this.successGrabarItem = this.successGrabarItem.bind(this);
        this.etapa_id = 0;
        this.setButtonDelete = this.setButtonDelete.bind(this);
        this.deleteEspecification = this.deleteEspecification.bind(this);
        this.succesEliminarItem = this.succesEliminarItem.bind(this);
        this.setButtonSubir = this.setButtonSubir.bind(this);
        this.cambiarOrden = this.cambiarOrden.bind(this);
        this.successChangeOrden = this.successChangeOrden.bind(this);
        this.setButtonBajar = this.setButtonBajar.bind(this);
        this.setSelectBodega = this.setSelectBodega.bind(this);
        this.valueChange = this.valueChange.bind(this);
        this.setSelectMaquina = this.setSelectMaquina.bind(this);
        this.grabarBodega = this.grabarBodega.bind(this);
        this.selectOptions = [];
        this.traerBodegas = this.traerBodegas.bind(this);
        this.successtraerBodegas = this.successtraerBodegas.bind(this);
        this.grabarBodega = this.grabarBodega.bind(this);
        this.successGrabarBodega = this.successGrabarBodega.bind(this);
        this.grabarTodo = this.grabarTodo.bind(this);
        this.cancelarFicha = this.cancelarFicha.bind(this);
        this.modalEnvase = this.modalEnvase.bind(this);
        this.guardarEnvase = this.guardarEnvase.bind(this);
        this.successGuardarEnvase = this.successGuardarEnvase.bind(this);
        this.productosDelEnvasado = this.productosDelEnvasado.bind(this);
        this.successProductosDelEnvasado = this.successProductosDelEnvasado.bind(this);
        this.cantidadxEnvasar = this.cantidadxEnvasar.bind(this);
        this.successCantidadxEnvasar = this.successCantidadxEnvasar.bind(this);
        this.setChangeProductosEnvasado = this.setChangeProductosEnvasado.bind(this);
        this.setChangeProductosEnvasadoclick = this.setChangeProductosEnvasadoclick.bind(this);
        this.successProductosDelEnvasadoClick = this.successProductosDelEnvasadoClick.bind(this);
        this.setChangeArticuloMaterialEmpaque = this.setChangeArticuloMaterialEmpaque.bind(this);
        this.setChangeArticuloMaterialEmpaqueClick = this.setChangeArticuloMaterialEmpaqueClick.bind(this);
        this.successArticuloMaterialEmpaqueClick = this.successArticuloMaterialEmpaqueClick.bind(this);
        this.formato3 = this.formato3.bind(this);
        this.envasadoInicialMaterialEmpaque = this.envasadoInicialMaterialEmpaque.bind(this)
        this.successEnvasadoInicialMaterialEmpaque = this.successEnvasadoInicialMaterialEmpaque.bind(this);
        this.setChangeEnvasadoIniMatEmpaque = this.setChangeEnvasadoIniMatEmpaque.bind(this);
        this.setChangeEnvasadoInicialclick = this.setChangeEnvasadoInicialclick.bind(this);
        this.successProductosDelEnvasadoInicialClick = this.successProductosDelEnvasadoInicialClick.bind(this);
        this.modalEnvaseIniMatEmpaque = this.modalEnvaseIniMatEmpaque.bind(this);
        this.successDataProductos = this.successDataProductos.bind(this);
        this.GrabarEnvIniMatEmpaque = this.GrabarEnvIniMatEmpaque.bind(this);
        this.successGrabarEnvIniMatEmpaque = this.successGrabarEnvIniMatEmpaque.bind(this);
        this.setButtonCantidadAgregada = this.setButtonCantidadAgregada.bind(this);
        this.cantidadAgregadaChange = this.cantidadAgregadaChange.bind(this);
        this.successCantidadAgregada = this.successCantidadAgregada.bind(this);
        this.setButtonCantidadMe = this.setButtonCantidadMe.bind(this);
        this.cantidadChangeMe = this.cantidadChangeMe.bind(this);
        this.successCantidadChangeMe = this.successCantidadChangeMe.bind(this);
        this.setButtonCantidadGalones = this.setButtonCantidadGalones.bind(this);
        this.cantidadKilosChange = this.cantidadKilosChange.bind(this);
        this.successCantidadKilosChange = this.successCantidadKilosChange.bind(this);
        this.uploadSelectProductos = this.uploadSelectProductos.bind(this);
        this.datosBodega = this.datosBodega.bind(this);
        this.successtraerBodegasSelect = this.successtraerBodegasSelect.bind(this);
        this.datosBodegaMatEmpaque = this.datosBodegaMatEmpaque.bind(this);
        this.successDatosBodegaMatEmpaque = this.successDatosBodegaMatEmpaque.bind(this);
        this.setButtonSaldos = this.setButtonSaldos.bind(this);
        this.verSaldos = this.verSaldos.bind(this);
        this.successVerSaldos = this.successVerSaldos.bind(this);
        this.retornaDatosFicha = this.retornaDatosFicha.bind(this);
        this.retornaEnvasado = this.retornaEnvasado.bind(this);
        this.retornaCantidadEnvasar = this.retornaCantidadEnvasar.bind(this);
        this.setButtonCambiar = this.setButtonCambiar.bind(this);
        this.cambiarSustitutos = this.cambiarSustitutos.bind(this);
        this.successCambiarArticulo = this.successCambiarArticulo.bind(this);
        this.successConfirmSustituto = this.successConfirmSustituto.bind(this);
        this.gridOptionsTBsustitutos = Object.assign({}, this.gridOptions);
        this.onSelectionChanged=this.onSelectionChanged.bind(this);
        this.gridOptionsTBsustitutos['onSelectionChanged']    =   this.onSelectionChanged;
        this.cambiarArticuloSustituto = this.cambiarArticuloSustituto.bind(this);
        this.id_registro = 0;
        this.verFormula = this.verFormula.bind(this);
        this.successVerFormula = this.successVerFormula.bind(this);

        this.onSelectionChangedVacio = this.onSelectionChangedVacio.bind(this);

        this.gridOptionsEnvasadoInicialMaterialEmpaque['onSelectionChanged']    =   this.onSelectionChangedVacio;
        this.gridOptionsProductosEnvasado['onSelectionChanged']    =   this.onSelectionChangedVacio;
        this.gridOptionsMaterialEmpaque['onSelectionChanged']    =   this.onSelectionChangedVacio;
        this.gridOptionsSaldos['onSelectionChanged']    =   this.onSelectionChangedVacio;
        this.gridOptions['onSelectionChanged']    =   this.onSelectionChangedVacio;

    }

    initForm() {
        console.log('Importar Datos, @version: 1.01.0054, @author:Cristian Ciro');

        this.getField('btnAgregar').setClick(this.openModalGrabar);
        this.getField('btnAgregarItem').setClick(this.grabarItem);
        this.getField('btnGrabar').setClick(this.grabarTodo);
        this.getField('btnCancelar').setClick(this.cancelarFicha);
        this.getField('btnAgregarEnvase').setClick(this.modalEnvase);
        this.getField('btnGuardarEnvase').setClick(this.guardarEnvase);
        this.getField('btnAgregarEnvIniMatEmpaque').setClick(this.modalEnvaseIniMatEmpaque)
        this.getField('btnGrabarEnvIniMatEmpaque').setClick(this.GrabarEnvIniMatEmpaque);
        this.getField('articulo_id').setOnChange(this.datosBodega);
        this.getField('articulo_id_matEmpaque').setOnChange(this.datosBodegaMatEmpaque);
        this.getField('artSustit_id').setOnChange(this.cambiarArticuloSustituto);
        this.retornaDatosFicha();
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    onSelectionChangedVacio(){

    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.data;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    retornaDatosFicha() {

        this.traerBodegas();
        let datos = {
            datos:{
                value: this.props.data.id_ficha,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Busca_una_ficha_por_id';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successDatosFicha,
                error: this.error_,
                general: this.generalFormat
            });*/
    }
    retornaEnvasado() {
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadoinicial', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDataProductos,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Retorna_fichas_envasado_por_ficha_id';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successDataProductos,
                error: this.error_,
                general: this.generalFormat
            });*/
    }
    retornaCantidadEnvasar() {
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        // produccion_fichas-cantidadporenvasar
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'cantidadporenvasar', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successCantidadxEnvasar,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*
        this.generalFormat.nombre_accion = '1-Retorna_la_cantidad_por_envasar';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successCantidadxEnvasar,
                error: this.error_,
                general: this.generalFormat
            });*/
    }
    datosBodega() {
        if (this.getField('articulo_id').getValue() !== '' && this.getField('articulo_id').getValue() !== ' ') {
            let datos = {
                datos:{
                    value: this.getField('articulo_id').getValue(),
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-articulo', operacion: 'saldobodegas', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successtraerBodegasSelect,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '1-Trae_el_saldo_referente_al_producto_para_el_select_de_bodegas';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: body,
                    success: this.successtraerBodegasSelect,
                    error: this.error_,
                    general: this.generalFormat,
                    showMessage: false
                });*/
        }
    }

    successtraerBodegasSelect(data) {
        let opciones = [{
            'text': 'Ninguno',
            'value': '',
            'campos_cambian': {}
        }];
        //this.getField('btnGrabar').setDisabled(false);


        if (data.estado_p === 200) {

            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = `${item.nombre_bodega} , saldo = ${item.saldo}`;
                dataOp['campos_cambian'] = { codigo_bodegaCod: item.codigo_bodega };
                opciones.push(dataOp);
            })
            this.getField('codigo_bodega_MPItems').setOptions(opciones);
        } else {
            this.getField('codigo_bodega_MPItems').setOptions(opciones);
        }
    }

    datosBodegaMatEmpaque() {
        if (this.getField('articulo_id_matEmpaque').getValue() !== '' && this.getField('articulo_id_matEmpaque').getValue() !== ' ') {
            /*let body = {
                value: this.getField('articulo_id_matEmpaque').getValue(),
            }
            this.generalFormat.nombre_accion = '1-Trae_el_saldo_referente_al_producto_para_el_select_de_bodegas';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: body,
                    success: this.successDatosBodegaMatEmpaque,
                    error: this.error_,
                    general: this.generalFormat,
                    showMessage: false
                });*/
            let datos = {
                datos:{
                    value: this.getField('articulo_id_matEmpaque').getValue(),
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-articulo', operacion: 'saldobodegas', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successDatosBodegaMatEmpaque,
                error: this.error_,
                general: this.generalFormatPmv
            });
        }
    }

    successDatosBodegaMatEmpaque(data) {
        let opciones = [{
            'text': 'Ninguno',
            'value': '',
            'campos_cambian': {}
        }];
        if (data.estado_p === 200) {

            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = `${item.nombre_bodega} , saldo = ${item.saldo}`;
                dataOp['campos_cambian'] = { codigo_bodegaCodME: item.codigo_bodega };
                opciones.push(dataOp);
            })
            this.getField('codigo_bodegaMe').setOptions(opciones);
        } else {
            this.getField('codigo_bodegaMe').setOptions(opciones);
        }
    }

    uploadSelectProductos() {
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadoinicial', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successDataProductos,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '1-Retorna_fichas_envasado_por_ficha_id';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successDataProductos,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successDataProductos(data) {
        let opciones = [{
            'text': 'Ninguno',
            'value': '',
            'campos_cambian': {}
        }];
        if (data.estado_p === 200) {

            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.codigo + "  " + item.nombre;;
                dataOp['campos_cambian'] = { produccion_fichas_envasado_inicial_id: item.id };
                opciones.push(dataOp);
            })
            this.getField('producto_terminado').setOptions(opciones);
        } else {
            this.getField('producto_terminado').setOptions(opciones);
        }
    }

    GrabarEnvIniMatEmpaque() {
        let datos = {
            datos: {
                produccion_fichas_id: this.props.data.id_ficha,
                articulo_id: this.getField('articulo_id_matEmpaque').getValue(),
                cantidad: this.getField('cantidad_matEmpaque').getValue(),
                produccion_fichas_envasado_inicial_id: this.getField('produccion_fichas_envasado_inicial_id').getValue(),
                codigo_bodega: this.getField('codigo_bodegaCodME').getValue().toString(),
                actividad_id: this.props.data.actividad_id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'crear', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successGrabarEnvIniMatEmpaque,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = "1-Permite_crear_un_material_de_empaque";
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: body,
                success: this.successGrabarEnvIniMatEmpaque,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successGrabarEnvIniMatEmpaque(response) {
        if (response.estado_p === 200) {
            this.getField('modalEnIniMatEmpaque').handleClose();
            this.envasadoInicialMaterialEmpaque();
        }
    }



    successDatosFicha(data) {
        if (data.estado_p === 200) {
            this.getField('lista_items_produccion').setVisible(true);
            this.getField('lista_items_produccion').setItemsFichas(data.data);
            this.itemsFichas();
        } else {
            this.getField('lista_items_produccion').setVisible(false);
        }
        this.retornaEnvasado();
        this.retornaCantidadEnvasar();
    }

    itemsFichas() {
        //console.log('entro a items fichas',this.props.data.id_ficha);
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        // produccion_fichas_items-fichaid

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successItemFichas,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Retorna_los_items_de_la_ficha';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successItemFichas,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successItemFichas(data) {
        //console.log('datos de la tabla de items',data);
        this.getField('articulo_id').setValue(' ');
        if (data.estado_p === 200) {
            this.tamanoDatos = data.data.length;
            
            if(this.tamanoDatos >= 2){
                if(data.data[this.tamanoDatos-1].etapa_id === data.data[this.tamanoDatos-2].etapa_id){
                    data.data[this.tamanoDatos-1].subir = true;
                }
            }

            this.gridOptions['rowData'] = [];
            this.getField('tablaItems').initData(this.gridOptions);
            let configCell = new Map();
            configCell.set(0, { cellRenderer: this.setButtonDelete, width: 80, field: 'Operación 1' });
            configCell.set(1, { cellRenderer: this.setButtonCambiar, width: 160, field: 'Operación 2' });
            configCell.set(2, { cellRenderer: this.setButtonSubir, width: 80, field: 'Operación 3' });
            configCell.set(3, { cellRenderer: this.setButtonBajar, width: 80, field: 'Operación 4' });
            configCell.set('saldos', { cellRenderer: this.setButtonSaldos, width: 125, field: 'Saldos' });
            configCell.set('orden', { cellStyle: { textAlign: "right" }, width: 30, field: 'orden' });
            configCell.set('nombre_unidad', { cellStyle: { textAlign: "right" }, width: 90, field: 'nombre_unidad' });
            configCell.set('actualizarbodega', { cellRenderer: this.setSelectBodega, cellStyle: { backgroundColor: "rgb(238,238,238)", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, width: 200, field: 'actualizar_bodega' });
            configCell.set('saldo1', {cellStyle: { textAlign: "right" }, field: 'Saldo 1' });
            configCell.set('codigo_producto', { field: 'codigo_producto' });
            configCell.set('cantidad_galones', { cellRenderer: this.setButtonCantidadGalones, cellStyle: { backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, onCellValueChanged: this.cantidadKilosChange, width: 100, editable: true, field: 'cantidad_galones' });
            configCell.set('cantidad_kilos', { cellRenderer: this.formato3, cellStyle: { textAlign: "right" }, field: 'cantidad_kilos' });
            this.gridOptions['rowData'] = data.data;
            this.getField('tablaItems').initData(this.gridOptions, configCell);
            this.productosDelEnvasado();

            const allColumnIds = [];
            this.gridOptions.columnApi.getAllColumns().forEach((column) => {
                allColumnIds.push(column.getId());
            });

            this.gridOptions.columnApi.autoSizeColumns(allColumnIds, false);
        } else {
            this.tamanoDatos = 0;
            this.getField('tablaItems').toggle(false);
        }
    }

    setButtonCambiar(props) {
        let button = document.createElement("input");
        button.onclick = () => this.cambiarSustitutos(props.data);
        button.setAttribute("class","buttonStyle");
        //button.setAttribute("style", "width: 90px;height: 20px;background-color: #303f9f;color: #fff;border: 1px solid #303f9f;padding-left: 5px;padding-right: 5px;padding-top: 2px;padding-bottom: 2px;border-radius: 3px;cursor: pointer;margin-right: 10px;");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Cambiar");
        return this.createElementJaivana(button);
    }

    cambiarSustitutos(data) {

        // prod-formulasproductossust-articuloid
        this.id_registro = data.id;
        let datos =  {
            datos:{
                value: data.articulo_id,
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'prod-formulasproductossust', operacion: 'articuloid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successConfirmSustituto,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-servicio_trae_por_art_id_prod_siustitutos';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successConfirmSustituto,
                error: this.error_,
                general: this.generalFormat
            });*/
    }
    

    successConfirmSustituto(data){
        if(data.estado_p === 200){
            
            //console.log('datos de los sustitutos',data);
            this.getField('tb_sustitutos').toggle(true);
            this.gridOptionsTBsustitutos['rowData'] = data.data;
            this.getField('tb_sustitutos').initData(this.gridOptionsTBsustitutos);
            this.getField('modal_sustitutos').handleClickOpen();
        }
    }

    onSelectionChanged() {
        let fila = this.gridOptionsTBsustitutos.api.getSelectedRows();
        //console.log('props',fila[0].articulo_id);
        if(fila[0])
            this.getField('artSustit_id').setValue(fila[0].articulo_sustituto_id);
    }

    cambiarArticuloSustituto() { 
        let artSusti = this.getField('artSustit_id').getValue();

        if(artSusti !== '' && artSusti !== ' ' && artSusti !== undefined){
            let datos =  {
                datos: {
                    id: this.id_registro,
                    articulo_id: artSusti,
                }
            };

            //console.log('body a enviar sustitu', body); cambiararticulo

            this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'cambiararticulo', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successCambiarArticulo,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '1-servicio_cambiar_articulo_reformulacion_inv_des';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: body,
                    success: this.successCambiarArticulo,
                    error: this.error_,
                    general: this.generalFormat
                }); */
        } 
    }

    successCambiarArticulo(data) {
        this.getField('modal_sustitutos').handleClose();
        if(data.estado_p === 200){
            //console.log('data del servicio de cambiar',data);
            this.itemsFichas();
            

        }
    }

    setButtonSaldos(props) {
        let button = document.createElement("input");
        button.onclick = () => this.verSaldos(props.data);
        button.setAttribute("class","buttonStyle");
        //button.setAttribute("style", "width: 90px;height: 20px;background-color: #303f9f;color: #fff;border: 1px solid #303f9f;padding-left: 5px;padding-right: 5px;padding-top: 2px;padding-bottom: 2px;border-radius: 3px;cursor: pointer;margin-right: 10px;");

        button.setAttribute("type", "button");
        button.setAttribute("value", "Ver saldo");
        return this.createElementJaivana(button);
    }

    verSaldos(data) {
        this.getField('modalSaldos').handleClickOpen();
        this.getField('codigo_articulo').setValue(data.codigo_producto);
        this.getField('nombre_articulo').setValue(data.nombre_articulo);
        /*let body = {
            value: data.articulo_id,
        }
        this.generalFormat.nombre_accion = '1-Trae_el_saldo_referente_al_producto_para_el_select_de_bodegas';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successVerSaldos,
                error: this.error_,
                general: this.generalFormat,
                showMessage: false,
            });*/
        let datos = {
            datos:{
                value: data.articulo_id,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-articulo', operacion: 'saldobodegas', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerSaldos,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successVerSaldos(data) {
        if (data.estado_p === 200) {
            this.gridOptionsSaldos['rowData'] = [];
            this.getField('TbBodegaSaldo').initData(this.gridOptionsSaldos);

            this.getField('TbBodegaSaldo').toggle(true);
            this.gridOptionsSaldos['rowData'] = data.data;
            this.gridOptionsSaldos.paginationPageSize = 100;
            this.getField('TbBodegaSaldo').initData(this.gridOptionsSaldos);

        } else {
            this.getField('TbBodegaSaldo').toggle(false);
            this.getField('fieldAlert').toggle(true, "No se encuentra ningún saldo", "error");
        }
    }

    setButtonCantidadGalones(props) {
        let valor_actual = props.data.cantidad_galones;
        let label = document.createElement("div");
        if (valor_actual !== null && valor_actual !== '' && valor_actual !== undefined && valor_actual >= 0) {
            label.textContent = "".formatoPrecio(valor_actual);
            if (props.data.saldo_insuficiente === true) {
                label.setAttribute('class', 'labelRed');
            }
        }
        else {
            label.textContent = 0;
            if (props.data.saldo_insuficiente === true) {
                label.setAttribute('class', 'labelRed');
            }
        }
        return this.createElementJaivana(label);
    }

    cantidadKilosChange(props) {
        this.getField('cantidad_kilos').setValue(props.data.cantidad_galones);
        let datos = {
            datos:{
                id: props.data.id,
                cantidad: this.getField('cantidad_kilos').getValue(),
                actividad_id: this.props.data.actividad_id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'cantidad', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successCantidadKilosChange,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Permite_cambiar_la_cantidad_de_kilos_de_una_ficha_items';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successCantidadKilosChange,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successCantidadKilosChange(response) {
        if (response.estado_p === 200) {
            this.getField('cantidad_kilos').setValue(' ');
            this.itemsFichas();
        }

    }

    formato3(props) {
        //console.log('Formato 3 antes',props.data.saldo_insuficiente);
        let label = document.createElement("div");
        label.textContent = "".formatoPrecio(props.data.cantidad_kilos);
        if (props.data.saldo_insuficiente === true) {
            label.setAttribute('class', 'labelRed');
            //console.log('Formato 3 despues',props.data.saldo_insuficiente);

        }
        return this.createElementJaivana(label);
    }

    openModalGrabar() {
        this.getField('ModalItemFichas').handleClickOpen();
    }
    grabarItem() {
        if (this.getField('articulo_id').valid() && this.getField('nombre').valid() && this.getField('cantidad').valid() &
            this.getField('codigo').valid() && this.getField('etapa_id').valid()) {

            this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
            this.getField('abastecimiento').setValue(1);
            this.getField('observacion').setValue('.');
            let datos = {
                datos:{
                    id_formulario: this.formId,
                    produccion_fichas_id: this.getField('produccion_fichas_id').getValue(),
                    etapa_id: this.getField('etapa_id').getValue(),
                    articulo_id: this.getField('articulo_id').getValue(),
                    cantidad: this.getField('cantidad').getValue(),
                    abastecimiento: this.getField('abastecimiento').getValue(),
                    observacion: this.getField('observacion').getValue(),
                    codigo_bodega: this.getField('codigo_bodegaCod').getValue().toString(),
                    actividad_id: this.props.data.actividad_id
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'crear', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGrabarItem,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*
            this.generalFormat.nombre_accion = '1-Produccion_fichas_items_crear';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successGrabarItem,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }
    }
    successGrabarItem(response) {
        if (response.estado_p === 200) {
            this.getField('fieldAlert').toggle(true, "Se agrego el item correctamente", "success");
            this.getField('codigo').setValue('');
            this.getField('nombre').setValue('');
            this.getField('cantidad').setValue('');
            this.getField('etapa_id').setValue('');
            this.getField('orden').setValue('');
            this.getField('ModalItemFichas').handleClose();
            this.itemsFichas();
        } else {
            this.getField('fieldAlert').toggle(true, "No se agrego el item correctamente", "error");
        }
    }
    setButtonDelete(props) {
        let id = props.data.id;
        let button = document.createElement("input");
        button.onclick = () => this.deleteEspecification(id);
        button.setAttribute("id", 'button_delete_' + id);
        //button.setAttribute("class","buttonStyle");
        button.setAttribute("class", "buttonStyle");//"width: 90px;height: 20px;background-color: #303f9f;color: #fff;border: 1px solid #303f9f;padding-left: 5px;padding-right: 5px;padding-top: 2px;padding-bottom: 2px;border-radius: 3px;cursor: pointer;margin-right: 10px;");
        button.setAttribute("type", "button");
        button.setAttribute("value", "X");
        return this.createElementJaivana(button);
    }
    deleteEspecification(id) {
        let datos = {
            datos:{
                id: id,
                actividad_id: this.props.data.actividad_id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'eliminar', operacion_tipo: 'eliminar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'DELETE',
            body: datos,
            success: this.succesEliminarItem,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Eliminar_produccion_fichas_items';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: body,
                success: this.succesEliminarItem,
                error: this.error_,
                general: this.generalFormat
            });*/
    }
    succesEliminarItem(response) {
        if (response.estado_p === 200) {
            this.getField('fieldAlert').toggle(true, "Se elimino el item correctamente", "success");
            this.itemsFichas();
        }
    }
    setButtonSubir(props) {
        let subir = props.data.subir;
        let id = props.data.id;
        //let orden = parseInt(props.data.orden);
        let position = parseInt(props.node.id);
        let div = document.createElement("div");
        let button = document.createElement("input");
        button.onclick = () => this.cambiarOrden(position, 1, id);
        button.setAttribute("id", 'button_subir_' + id);
        button.setAttribute("class","buttonStyle");
        //button.setAttribute("style", "width: 90px;height: 20px;background-color: #303f9f;color: #fff;border: 1px solid #303f9f;padding-left: 5px;padding-right: 5px;padding-top: 2px;padding-bottom: 2px;border-radius: 3px;cursor: pointer;margin-right: 10px;");
        button.setAttribute("type", "button");
        button.setAttribute("value", "↑");
        if (!subir/*orden === 1*/) {
            //button.setAttribute("style","width:100%;height: 100%; background-color:#ccc;color:#fff;border:1px solid #fff;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
            button.setAttribute("class", "buttonDisabled");
        }
        div.appendChild(button);
        return this.createElementJaivana(button);
    }
    cambiarOrden(pos, opciond, id) {
        let datos = {
            datos:{
                id: id,
                opcion: (opciond === 1) ? 'subir' : 'bajar',
                actividad_id: this.props.data.actividad_id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'cambiarorden', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successChangeOrden,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Permite_cambiar_en_oden_de_una_ficha_items';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successChangeOrden,
                error: this.error_,
                general: this.generalFormat
            });*/
    }
    successChangeOrden(response) {
        if (response.estado_p === 200) {
            this.getField('fieldAlert').toggle(true, "Se cambio el orden del item correctamente", "success");
            this.itemsFichas();
            this.getField('opcion').setValue('');
        } else {
            this.getField('fieldAlert').toggle(true, "No se cambio el orden del item correctamente", "error");
        }
    }
    setButtonBajar(props) {
        let bajar = props.data.bajar;
        let id = props.data.id;
        //let orden = parseInt(props.data.orden);
        let position = parseInt(props.node.id);
        let button = document.createElement("input");
        button.onclick = () => this.cambiarOrden(position, 0, id);
        button.setAttribute("id", 'button_bajar_' + id);
        button.setAttribute("class","buttonStyle");//,"width:100%; height: 100%; background-color:#303f9f;color:#fff;border:1px solid #303f9f;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
        //button.setAttribute("style", "width: 90px;height: 20px;background-color: #303f9f;color: #fff;border: 1px solid #303f9f;padding-left: 5px;padding-right: 5px;padding-top: 2px;padding-bottom: 2px;border-radius: 3px;cursor: pointer;margin-right: 10px;");

        button.setAttribute("type", "button");
        button.setAttribute("value", "↓");
        if (!bajar/*orden === 4*/) {
            //button.setAttribute("style","width:100%; height: 100%; background-color:#ccc;color:#fff;border:1px solid #fff;padding-left:5px;padding-rigth:5px;padding-top:2px;padding-bottom:2px;border-radius:3px; cursor:pointer");
            button.setAttribute("class", "buttonDisabled");

        }
        return this.createElementJaivana(button);
    }

    traerBodegas() {
        let datos = {
            datos:{}
        }
        // produccion_fichas_items-bodega
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'bodega', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successtraerBodegas,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Busca_los_datos_de_las_bodegas';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successtraerBodegas,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successtraerBodegas(data) {
        if (data.estado_p === 200) {
            this.selectOptions = data.data;
        } else {
            this.getField('fieldAlert').toggle(true, "No se tienen bodegas para mostrar", "error");
        }
    }


    setSelectBodega(props) {
        let maquina = props.data.codigo_bodega;
        let select = document.createElement("select");
        let div = document.createElement('div');
        //div.setAttribute('class', 'width: 100%; heigth: 100%; padding-top: 4px');
        select.setAttribute('class', 'custom-select');
        select.onchange = (event) => this.valueChange(event, props.data.id);
        let opciones = this.setSelectMaquina();
        this.valor_idMaq = 1;
        opciones.map((item) => {
            select.appendChild(item);
            if (item.value === maquina)
                this.valor_idMaq = item.value;
            return null;
        })
        div.appendChild(select)
        if (maquina === null || maquina === undefined)
            this.valido = false;
        else
            select.value = this.valor_idMaq;
        return this.createElementJaivana(div);
    }

    valueChange(props, celda) {
        let x = parseInt(props.target.value);
        if (!isNaN(x))
            this.grabarBodega(celda, x);
        else
            this.itemsFichas();
    }

    setSelectMaquina() {
        let opcionN = document.createElement('option');
        opcionN.setAttribute('value', ' ');
        opcionN.textContent = 'Ninguno';

        let data = [opcionN];
        this.selectOptions.map((item) => {
            let opcion = document.createElement('option');
            opcion.setAttribute('value', item.codigo_bodega);
            opcion.textContent = item.nombre_bodega;
            data.push(opcion);
            return null;
        })
        return data;
    }

    grabarBodega(idCell, bodega_id) {
        this.getField('codigo_bodega_tbItems').setValue(bodega_id)
        let datos = {
            datos:{
                id: idCell,
                codigo_bodega: this.getField('codigo_bodega_tbItems').getValue().toString(),
                actividad_id: this.props.data.actividad_id
            }
        }
        //console.log('entro a  grabar bodega',body);
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'cambiarbodega', operacion_tipo: 'modificar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'PUT',
            body: datos,
            success: this.successGrabarBodega,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '1-Permite_cambiar_la_bodega_de_una_ficha_items';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successGrabarBodega,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successGrabarBodega(response) {
        if (response.estado_p === 200) {
            this.getField('fieldAlert').toggle(true, "Se actualizo la bodega correctamente", "success");
            this.itemsFichas();
        } else {
            this.getField('fieldAlert').toggle(true, "No se actualizo la bodega correctamente", "error");
        }
    }

    grabarTodo() {
        if (this.tamanoDatos > 0) {
            this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
            this.getField('proceso_id').setValue(this.props.data.proceso_id);
            this.getField('actividad_id').setValue(this.props.data.actividad_id);
            this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);

            let datos = {
                datos:{
                    id_formulario: this.formId,
                    produccion_fichas_id: this.getField('produccion_fichas_id').getValue(),
                    proceso_id: this.getField('proceso_id').getValue(),
                    actividad_id: this.getField('actividad_id').getValue(),
                    actividad_configuracion_id: this.getField('actividad_configuracion_id').getValue(),
                }
            }
            this.getField('btnGrabar').setDisabled(true);

            this.generalFormatPmv = { tipo_servicio: 'prod-fichasitems', operacion: 'grabar', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormatPmv
            });

            /*this.generalFormat.nombre_accion = '1-Permite_grabar_continuar_a_la_siguiente_etapa';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successCloseEstage,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        } else
            this.alertGeneral.toggle(true, 'Debe haber mínimo un producto agregado', "error");
    }

    cancelarFicha() {
        if (this.getField('observaciones_cancelacion').getValue() !== '' && this.getField('observaciones_cancelacion').getValue() !== ' ') {
            this.getField('observaciones_cancelacion').setError(false, "");
            this.getField('id').setValue(this.props.data.id_ficha);
            this.getField('proceso_id').setValue(this.props.data.proceso_id);
            this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
            let datos = {
                datos:{
                    id_formulario: this.formId,
                    id: this.getField('id').getValue(),
                    observaciones_cancelacion: this.getField('observaciones_cancelacion').getValue(),//observaciones_cancelacion
                    proceso_id: this.getField('proceso_id').getValue(),
                    actividad_configuracion_id: this.getField('actividad_configuracion_id').getValue(),
                    actividad_id: this.props.data.actividad_id
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'observacioncancelacion', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successCloseEstage,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '1-Permite_cancelar_observacion_ficha';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: body,
                    success: this.successCloseEstage,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        } else {
            this.getField('fieldAlert').toggle(true, "El campo observación es requerido", "error");
        }
    }

    modalEnvase() {
        this.getField('modalEnvase').handleClickOpen();
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('produccion_kit_id').setValue('');
        this.getField('codigo_producto').setValue('');
        this.getField('nombre_producto').setValue('');
        this.getField('factor').setValue('');
        this.getField('kit').setValue('');
        this.getField('descripcion').setValue('');
        this.getField('id_articulo').setValue('');
        this.getField('es_envasado_id').setValue('');
    }

    guardarEnvase() {
        if (this.getField('cantidad_envasado').getValue() !== '' && this.getField('cantidad_envasado').getValue() !== ' ') {
            this.getField('cantidad_envasado').setError(false, "");
            let datos = {
                datos: {
                    produccion_fichas_id: this.props.data.id_ficha,
                    articulo_id: this.getField('id_articulo').getValue(),
                    cantidad: this.getField('cantidad_envasado').getValue(),
                    produccion_kit_id: this.getField('produccion_kit_id').getValue(),
                    actividad_id: this.props.data.actividad_id
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadoinicial', operacion: 'crear', operacion_tipo: 'crear' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'POST',
                body: datos,
                success: this.successGuardarEnvase,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = "1-Crea_una_ficha_envasado";
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'POST',
                    body: body,
                    success: this.successGuardarEnvase,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        } else {
            if (this.getField('cantidad_envasado').valid() && this.getField('cantidad_envasado').getValue() === '') {
                this.getField('cantidad_envasado').setError(true, "Este campo es requerido");
            }
        }
    }

    successGuardarEnvase(response) {
        if (response.estado_p === 200) {
            this.getField('fieldAlert').toggle(true, "Ficha envasado creada exitosamente", "success");
            this.getField('modalEnvase').handleClose();
            this.productosDelEnvasado();
            this.uploadSelectProductos();
        } else {
            this.getField('fieldAlert').toggle(true, "La ficha envasado no pudo ser creada", "error");
        }
    }

    productosDelEnvasado() {
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadoinicial', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successProductosDelEnvasado,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Retorna_fichas_envasado_por_ficha_id';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successProductosDelEnvasado,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successProductosDelEnvasado(data) {
        if (data.estado_p === 200) {
            this.gridOptionsProductosEnvasado['rowData'] = [];
            this.getField('TbProductosDelEnvasado').initData(this.gridOptionsProductosEnvasado);
            this.getField('TbProductosDelEnvasado').toggle(true);
            this.gridOptionsProductosEnvasado['rowData'] = data.data;
            this.gridOptionsProductosEnvasado.paginationPageSize = 100;
            let configCellcol = new Map();
            configCellcol.set('cantidad', { cellRenderer: this.setButtonCantidadAgregada, cellStyle: { backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, onCellValueChanged: this.cantidadAgregadaChange, width: 100, editable: true, field: 'cantidad' });
            configCellcol.set('accion', { cellRenderer: this.setChangeProductosEnvasado, width: 80, field: 'Acción' });
            this.getField('TbProductosDelEnvasado').initData(this.gridOptionsProductosEnvasado, configCellcol);
            this.cantidadxEnvasar();
            this.envasadoInicialMaterialEmpaque();

            const allColumnIds = [];
            this.gridOptionsProductosEnvasado.columnApi.getAllColumns().forEach((column) => {
                allColumnIds.push(column.getId());
            });

            this.gridOptionsProductosEnvasado.columnApi.autoSizeColumns(allColumnIds, false);
        } else {
            this.getField('TbProductosDelEnvasado').toggle(false);
            this.getField('fieldAlert').toggle(true, "No hay envasado", "error");
            this.cantidadxEnvasar();
        }
    }

    setButtonCantidadAgregada(props) {
        let valor_actual = props.data.cantidad;
        let div = document.createElement("div");
        let label = document.createElement("label");
        if (valor_actual !== null && valor_actual !== '' && valor_actual !== undefined && valor_actual >= 0) {
            label.textContent = "".formatoPrecio(valor_actual);
        }
        else {
            label.textContent = 0;
            if (props.data.saldo_insuficiente === true) {
                label.setAttribute('class', 'labelRed');
            }
        }
        div.appendChild(label);
        return this.createElementJaivana(div);
    }

    cantidadAgregadaChange(props) {
        let seguir = this.getField('TbProductosDelEnvasado').cellValid(props.oldValue, props.newValue, '^[0-9]'); // Se valida que el dato ingresado sea un numero
        if (props.newValue < 0) {
            props.data.cantidad = 0;
        }
        if (seguir) {
            this.getField('cantidadProductoTerminado').setValue(props.newValue);
            let datos = {
                datos: {
                    id: props.data.id,
                    cantidad: this.getField('cantidadProductoTerminado').getValue(),
                    actividad_id: this.props.data.actividad_id
                }
            }
            // prod-fichasenvasadoinicial
            this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadoinicial', operacion: 'cantidad', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successCantidadAgregada,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '1-Permite_cambiar_la_cantidad_del_registro';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: body,
                    success: this.successCantidadAgregada,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }
    }

    successCantidadAgregada(response) {
        if (response.estado_p === 200) {
            this.getField('cantidadProductoTerminado').setValue(' ');
            this.productosDelEnvasado();
        }
    }

    cantidadxEnvasar() {
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'cantidadporenvasar', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successCantidadxEnvasar,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '1-Retorna_la_cantidad_por_envasar';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successCantidadxEnvasar,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successCantidadxEnvasar(data) {
        if (data.estado_p === 200) {
            let datamodel = data.data;
            this.getField('total_envasado').setValue(datamodel[0].total_envasado);
            this.getField('restante_envasar').setValue(datamodel[0].restante_envasar);
        }
    }

    envasadoInicialMaterialEmpaque() {
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'fichaid', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successEnvasadoInicialMaterialEmpaque,
            error: this.error_,
            general: this.generalFormatPmv
        });
        // produccion_fichas_envasado_material_empaque-fichaid
        /*this.generalFormat.nombre_accion = '1-Retorna_el_material_de_empaque_por_el_id_de_la_ficha';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: body,
                success: this.successEnvasadoInicialMaterialEmpaque,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successEnvasadoInicialMaterialEmpaque(data) {
        if (data.estado_p === 200) {
            this.gridOptionsEnvasadoInicialMaterialEmpaque['rowData'] = [];
            this.getField('tbEnvasadoIniMatEmpaque').initData(this.gridOptionsEnvasadoInicialMaterialEmpaque);
            let configCellcol = new Map();
            configCellcol.set('cantidad', { cellRenderer: this.setButtonCantidadMe, cellStyle: { backgroundColor: "rgb(238,238,238)", textAlign: "right", borderRadius: "5px", color: 'rgb(0, 86, 201)' }, onCellValueChanged: this.cantidadChangeMe, width: 100, editable: true, field: 'cantidad' });
            configCellcol.set('accion', { cellRenderer: this.setChangeEnvasadoIniMatEmpaque, width: 80, field: 'Acción' });
            this.getField('tbEnvasadoIniMatEmpaque').toggle(true);
            this.gridOptionsEnvasadoInicialMaterialEmpaque['rowData'] = data.data;
            this.gridOptionsEnvasadoInicialMaterialEmpaque.paginationPageSize = 100;
            this.getField('tbEnvasadoIniMatEmpaque').initData(this.gridOptionsEnvasadoInicialMaterialEmpaque, configCellcol);

            const allColumnIds = [];
            this.gridOptionsEnvasadoInicialMaterialEmpaque.columnApi.getAllColumns().forEach((column) => {
                allColumnIds.push(column.getId());
            });

            this.gridOptionsEnvasadoInicialMaterialEmpaque.columnApi.autoSizeColumns(allColumnIds, false);
        } else {
            this.getField('tbEnvasadoIniMatEmpaque').toggle(false);
            this.getField('fieldAlert').toggle(true, "No hay envasado material empaque", "error");
        }
    }

    setButtonCantidadMe(props) {
        let valor_actual = props.data.cantidad;
        let div = document.createElement("div");
        let label = document.createElement("label");
        if (valor_actual !== null && valor_actual !== '' && valor_actual !== undefined && valor_actual >= 0) {
            label.textContent = "".formatoPrecio(valor_actual);
            if (props.data.saldo_insuficiente === true) {
                label.setAttribute('class', 'labelRed');
            }
        }
        else {
            label.textContent = 0;
            if (props.data.saldo_insuficiente === true) {
                label.setAttribute('class', 'labelRed');
            }
        }
        div.appendChild(label);
        return this.createElementJaivana(div);
    }

    cantidadChangeMe(props) {
        let seguir = this.getField('tbEnvasadoIniMatEmpaque').cellValid(props.oldValue, props.newValue, '^[0-9]'); // Se valida que el dato ingresado sea un numero
        if (props.newValue < 0) {
            props.data.cantidad = 0;
        }
        if (seguir) {
            this.getField('cantidadMaterialEmpaque').setValue(props.newValue);
            let datos = {
                datos: {
                    id: props.data.id,
                    cantidad: this.getField('cantidadMaterialEmpaque').getValue(),
                    actividad_id: this.props.data.actividad_id
                }
            }
            this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'cantidad', operacion_tipo: 'modificar' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'PUT',
                body: datos,
                success: this.successCantidadChangeMe,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = '1-Permite_cambiar_la_cantidadTb2MatEmpaque';
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: body,
                    success: this.successCantidadChangeMe,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }
    }

    successCantidadChangeMe(response) {
        if (response.estado_p === 200) {
            this.getField('cantidadMaterialEmpaque').setValue(' ');
            this.envasadoInicialMaterialEmpaque();
        }
    }

    setChangeEnvasadoIniMatEmpaque(props) {
        let button = document.createElement("input");
        button.onclick = () => this.setChangeEnvasadoInicialclick(props.data);
        button.setAttribute("class","buttonStyle");

        button.setAttribute("type", "button");
        button.setAttribute("value", "X");
        return this.createElementJaivana(button);
    }

    setChangeEnvasadoInicialclick(data) {
        let datos = {
            datos:{
                id: data.id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'eliminar', operacion_tipo: 'eliminar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'DELETE',
            body: datos,
            success: this.successProductosDelEnvasadoInicialClick,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Permite_eliminar_un_material_de_empaque';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: body,
                success: this.successProductosDelEnvasadoInicialClick,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successProductosDelEnvasadoInicialClick(response) {
        if (response.estado_p === 200) {
            this.envasadoInicialMaterialEmpaque();
        }
    }

    setChangeProductosEnvasado(props) {
        let button = document.createElement("input");
        button.onclick = () => this.setChangeProductosEnvasadoclick(props.data);
        button.setAttribute("class","buttonStyle");

        button.setAttribute("type", "button");
        button.setAttribute("value", "X");
        return this.createElementJaivana(button);
    }

    setChangeProductosEnvasadoclick(data) {
        let datos = {
            datos:{
                id: data.id
            }
        }
        this.generalFormatPmv = { tipo_servicio: 'prod-fichasenvasadoinicial', operacion: 'eliminar', operacion_tipo: 'eliminar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'DELETE',
            body: datos,
            success: this.successProductosDelEnvasadoClick,
            error: this.error_,
            general: this.generalFormatPmv
        });

        /*this.generalFormat.nombre_accion = '1-Elimina_una_ficha_envasado';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: body,
                success: this.successProductosDelEnvasadoClick,
                error: this.error_,
                general: this.generalFormat
            });*/
    }
    successProductosDelEnvasadoClick(response) {
        if (response.estado_p === 200) {
            this.productosDelEnvasado();
            this.uploadSelectProductos();
        }
    }

    setChangeArticuloMaterialEmpaque(props) {
        let button = document.createElement("input");
        button.onclick = () => this.setChangeArticuloMaterialEmpaqueClick(props.data);
        button.setAttribute("class","buttonStyle");

        button.setAttribute("type", "button");
        button.setAttribute("value", "Eliminar");
        return this.createElementJaivana(button);
    }
    setChangeArticuloMaterialEmpaqueClick(data) {
        let datos = {
            datos: {
                id: data.id
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-envasadoinicialmaterialempaque', operacion: 'eliminar', operacion_tipo: 'eliminar' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'DELETE',
            body: datos,
            success: this.successArticuloMaterialEmpaqueClick,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1-Permite_eliminar_un_material_de_empaque';
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: body,
                success: this.successArticuloMaterialEmpaqueClick,
                error: this.error_,
                general: this.generalFormat
            });*/
    }
    successArticuloMaterialEmpaqueClick(response) {
        if (response.estado_p === 200) {
            this.uploadTable();
        }
    }

    modalEnvaseIniMatEmpaque() {
        this.getField('modalEnIniMatEmpaque').handleClickOpen();
        this.getField('codigo_producto_matEmpaque').setValue('');
        this.getField('nombre_producto_matEmpaque').setValue('');
        this.getField('articulo_id_matEmpaque').setValue('');
        this.getField('cantidad_matEmpaque').setValue('');
        this.getField('producto_terminado').setValue('');
        this.getField('produccion_fichas_envasado_inicial_id').setValue('');
    }
}
FormJaivana.addController("prod-investigaciondes", CustomInvestigacionYDesarrollo);
export default CustomInvestigacionYDesarrollo;